import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Wallet, Chrome } from 'lucide-react';

const Login = () => {
  const { signInWithGoogle } = useAuth();
  const [signingIn, setSigningIn] = useState(false);
  const [error, setError] = useState('');

  const handleGoogleSignIn = async () => {
    try {
      setSigningIn(true);
      setError('');
      await signInWithGoogle();
    } catch (error) {
      console.error('Error signing in:', error);
      setError('Error al iniciar sesión. Por favor, intenta de nuevo.');
    } finally {
      setSigningIn(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center p-4 safe-area-top safe-area-bottom">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-2xl p-6 md:p-8">
          <div className="text-center mb-6 md:mb-8">
            <div className="flex items-center justify-center gap-2 md:gap-3 mb-4">
              <Wallet className="w-10 h-10 md:w-12 md:h-12 text-blue-600" />
              <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
                Gestor de Finanzas
              </h1>
            </div>
            <p className="text-gray-600 text-sm md:text-base">
              Inicia sesión para acceder a tu gestor de finanzas personales
            </p>
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg mb-6 text-sm">
              {error}
            </div>
          )}

          <button
            onClick={handleGoogleSignIn}
            disabled={signingIn}
            className="w-full bg-white border-2 border-gray-300 rounded-lg px-6 py-4 flex items-center justify-center gap-3 hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
            style={{ minHeight: '56px' }}
          >
            <Chrome className="w-5 h-5 md:w-6 md:h-6" />
            <span className="font-medium text-gray-700">
              {signingIn ? 'Iniciando sesión...' : 'Continuar con Google'}
            </span>
          </button>

          <div className="mt-6 text-center">
            <p className="text-xs md:text-sm text-gray-500">
              Al continuar, aceptas los términos de servicio
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;